<template>
  <div id="app" class="app-content mb-4" v-if="profile.author">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <SettingsMenu></SettingsMenu>
            <ProfileSection></ProfileSection>
            <MainBalance></MainBalance>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { mapActions, mapState } from "vuex";
import AppHeader from "../reuseable_components/Header.vue";
import country from "../../js/country";
import SettingsMenu from "./SettingsMenu.vue";
import ProfileSection from "./ProfileSection.vue";
import MainBalance from "./MainBalance.vue";

export default {
  name: "Profile",
  components: {
    "app-header": AppHeader,
    SettingsMenu: SettingsMenu,
    ProfileSection: ProfileSection,
    MainBalance: MainBalance,
  },
  computed: {
    ...mapState(["profile", "successmessage", "errormessage", "message"]),
  },
  created() {
    this.listProfile();
  },
  mounted: function () {
    if (this.$store.state.token == "") {
      this.$router.replace("/");
    }
  },

  data() {
    return {
      image: "",
      first_name: "",
      last_name: "",
      street_address: "",
      city: "",
      state: "",
      country: "",
      middle_name: "",
      countries: country,
      errors: [],
    };
  },

  methods: {
    ...mapActions(["listProfile"]),
    handleProfileUpdateForm() {
      let formData = new FormData();
      formData.append("image", this.profile.author.image);
      formData.append("first_name", this.profile.author.first_name);
      formData.append("last_name", this.profile.author.last_name);
      formData.append("email", this.profile.author.email);
      this.$store.dispatch("updateProfile", formData).then(() => {
        if (this.successmessage == "success") {
          location.reload();
          // this.$refs.modal1.hide();
          // this.$bvToast.show('successprofile-toast');
        } else if (this.errormessage == "errormessage") {
          // this.dismissCountDown2 = this.dismissSecs
          this.$refs.modal1.hide();
          this.$bvToast.show("errorprofile-toast");
        }
      });
    },
    handleFileUpload() {
      this.image = this.$refs.file.files[0];
    },

    editshippingAddress() {
      this.errors = [];
      if (this.street_address == "") {
        this.errors["street_address"] = "Street Address required.";
      } else if (this.country == "") {
        this.errors["country"] = "Country required.";
      } else if (this.city == "") {
        this.errors["city"] = "City required.";
      } else if (this.state == "") {
        this.errors["state"] = "State required.";
      } else {
        this.$store
          .dispatch("createaddress", {
            street_address: this.street_address,
            country: this.country,
            city: this.city,
            state: this.state,
            address_type: "shipping",
          })
          .then(() => {
            if (this.successmessage == "success") {
              // location.reload();
              this.$refs.modal3.hide();
              this.$bvToast.show("success-saddr-toast");
            } else if (this.errormessage == "errormessage") {
              // this.dismissCountDown = this.dismissSecs
              this.$refs.modal3.hide();
              this.$bvToast.show("error-saddr-toast");
            }
          });
        // this.$router.replace({name:"profile"});
      }
    },

    editbillingAddress() {
      this.errors = [];
      if (this.street_address == "") {
        this.errors["street_address"] = "Street Address required.";
      } else if (this.country == "") {
        this.errors["country"] = "Country required.";
      } else if (this.city == "") {
        this.errors["city"] = "City required.";
      } else if (this.state == "") {
        this.errors["state"] = "State required.";
      } else {
        this.$store
          .dispatch("createaddress", {
            street_address: this.street_address,
            country: this.country,
            city: this.city,
            state: this.state,
            address_type: "billing",
          })
          .then(() => {
            if (this.successmessage == "success") {
              // location.reload();
              this.$refs.modal2.hide();
              this.$bvToast.show("success-baddr-toast");
            } else if (this.errormessage == "errormessage") {
              // this.dismissCountDown1 = this.dismissSecs
              this.$refs.modal2.hide();
              this.$bvToast.show("error-baddr-toast");
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>
